import { render, staticRenderFns } from "./FavouriteView.vue?vue&type=template&id=431897ea"
import script from "./FavouriteView.vue?vue&type=script&lang=js"
export * from "./FavouriteView.vue?vue&type=script&lang=js"
import style0 from "./FavouriteView.vue?vue&type=style&index=0&id=431897ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports